'use client';
import React from 'react';

export default function ServicesSection() {
  const services = [
    {
      icon: '/assets/img/service/workers.png',
      title: 'Tender-Based Manpower Supply',
      link: 'service-details.html',
      description:
        'Skilled, semi-skilled, and unskilled workers for government tenders (e.g. railway cleaning, facility staffing, public infrastructure projects)',
      delay: 100,
    },
    {
      icon: '/assets/img/service/Construction-worker.png',
      title: 'Technical & Engineering Staff Supply',
      link: 'service-details.html',
      description:
        'Engineers, site supervisors, QA/QC, surveyors, foremen, and technical support teams for industrial and infrastructure projects',
      delay: 200,
    },
    {
      icon: '/assets/img/service/support.png',
      title: 'Facility & Support Staffing',
      link: 'service-details.html',
      description:
        'Paramedical staff, hospital support, housekeeping, security guards, administrative and clerical staff for hospitals, institutes, and campuses',
      delay: 300,
    },
    {
      icon: '/assets/img/service/security.png',
      title: 'Security & Guard Services',
      link: 'service-details.html',
      description:
        'Trained personnel, ex-army/Security Officers, armed guards for institutional, plant, or TEMPLE/heritage zone security needs',
      delay: 400,
    },
    {
      icon: '/assets/img/service/Industrial-worker.png',
      title: 'Industrial & Construction Labor',
      link: 'service-details.html',
      description:
        'Machine operators, heavy equipment operators, construction labor, plant maintenance and housekeeping workers for municipal & PSU contracts',
      delay: 500,
    },
    {
      icon: '/assets/img/service/staff.png',
      title: 'Contract & Temporary Staffing',
      link: 'service-details.html',
      description:
        'Project-based and seasonal workforce for temporary or short-term assignments across sectors',
      delay: 600,
    },
  ];

  return (
    <section id="services" className="services section">
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <p>Check our Services</p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {services.map((service, index) => (
            <div
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-delay={service.delay}
              key={index}
            >
              <div className="service-item position-relative">
                
                <div className="icon">
                   <img src={service.icon} alt="Stats" className="img-service img-fluid" />
                   {/*<i className={`bi ${service.icon}`}></i>*/}
                </div>
                <a href={service.link} className="stretched-link">
                  <h3>{service.title}</h3>
                </a>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
